angular.module('gym.components').directive('featureToggle', function() {
  return {
    restrict: 'E',
    template: require('templates/components/shared/feature_toggle.html.slim'),
    scope: {
      isFeatureEnabled: '=',
      name: '@',
      optIn: '&',
      onViewPricingClick: '&'
    },
    controller: ["$scope", function($scope) {
      return $scope.isPayor = window.currentUser.account_owner;
    }]
  };
});
